import { ROLES } from 'features/Permission/constants'
import { IUser } from 'redux/store/user/types'

export const isHospitalFamilyUser = (user: IUser): boolean =>
  user.role === ROLES.HOSPITAL_ADMIN || user.role === ROLES.HOSPITAL_USER

export const isCommunityLeadership = (user: IUser): boolean =>
  user.role === ROLES.COMMUNITY_PRESIDENT ||
  user.role === ROLES.VICE_PRESIDENT ||
  user.role === ROLES.CONTRACT_STEWARD
